import React from 'react';
import { Alert } from 'antd';

import StandardSteps from 'components/StandardSteps';
import StatusRadioGroup from 'components/StatusRadioGroup';

export default class MedicalHistory extends React.Component {
	state = {
		submitEmail: 'CSUHN_records@mail.colostate.edu',
		contactEmail: 'medical@semesteratsea.org',
	}

	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'health/medicalhistory');
			if (redirect) return redirect;
		}
		const fa19Checklist = 'http://www.semesteratsea.org/wp-content/uploads/2019/04/FA19-Medical-Clearance-Checklist-Final-030119.pdf'
		const fa18Checklist = 'http://www.semesteratsea.org/wp-content/uploads/2018/03/FA18-Medical-Clearance-Checklist.pdf'
		const fa18Form = 'http://www.semesteratsea.org/wp-content/uploads/2018/03/FA18-Medical-History-Form-for-Students-and-LLLs.pdf'
		const sp19Form = 'http://www.semesteratsea.org/wp-content/uploads/2018/08/SP-19-Medical-History-Form-Students-LLL-062918.pdf?utm_source=hs_email&utm_medium=email&utm_content=65088273&_hsenc=p2ANqtz-_p-KmpDqBudMGSf7tP0tbLbPA3MJ9wRbYUX6CMw5RmyterWFBZ-V6JTf1dVVBN4IwnuIhBxc5hwM8Omr_ywnsz01HE3g&_hsmi=65088273'
		const code = (this.props.statuses) ? this.props.statuses.SRI_MED_HIST_STAT : null;
		const fa19ConcernsForm = 'http://www.semesteratsea.org/wp-content/uploads/2019/04/FA19-Travel-Medical-Concerns-Final-030119.pdf'
		const sp20ConcernsForm = 'http://www.semesteratsea.org/wp-content/uploads/2019/10/SP-20-Travel-Medical-Concerns-071719.pdf'
		if (this.props.variant === 'admin') {
			return (
				<div className="withSpacing">
					<h2>Form Status</h2>
					{this.props.statusesLoaded &&
						<StatusRadioGroup
							statusType="SRI_MED_HIST_STAT"
							onChange={this.props.handleStatusChange}
							value={code} />
					}
				</div>
			);
		}
		else {
			return (
				<div className="withSpacing">
					<h2>Form Status</h2>
					<Alert showIcon
						type="info"
						message={<span>Form Required: <a target="_blank"
							href={this.props.isStudent || this.props.isGapOrPost || this.props.isLLL ? 'http://www.semesteratsea.org/wp-content/uploads/2019/10/Spr20-med-hx-form.pdf' : 'http://www.semesteratsea.org/wp-content/uploads/2019/04/FA19-Medical-History-Form-Staculty-Final-030119.pdf'} >
							Medical History</a></span>}
						description={
							<span>
								<div>You will not be able to participate in the voyage without a completed and approved Medical History Form. <font style={{ color: 'red' }}>The deadline to return the Medical History Form to </font><a href={'mailto:' + 'medical@semesteratsea.org'}>{'medical@semesteratsea.org'}</a><font style={{ color: 'red' }}> is Nov 1st, 2019.</font></div>
							</span>} />
					<br />
					<Alert showIcon
						type="info"
						message={<span><a target="_blank" href={sp20ConcernsForm}>SAS Travel Medical Concerns Guide</a></span>}
						description={<span>Please be sure to read the <a target="_blank" href={sp20ConcernsForm}>SAS Travel Medical Concerns Guide</a> and share it with your physician. 
							<br />
							You should plan to obtain enough prescription medications to last for the entire voyage, as medication cannot be shipped internationally. All prescription medications being brought to the ship must be in original containers (per month) with pharmacy labeling including your name, medication, and instructions clearly displayed.  

						</span>} />
						<br />
						<Alert showIcon
					type="info"
					message={<span><a target="_blank" href={this.props.booking.EventId === '38' ? fa19Checklist : fa18Checklist}>Medical Checklist</a></span>} />
					<br />

					<h2>Medical History Form Status</h2>
					<StandardSteps code={code} />
					{code === 'I' &&
						<Alert showIcon
							type="error"
							description={<span>Please email <a href={'mailto:' + this.state.contactEmail}>{this.state.contactEmail}</a></span>} />
					}
					<br />
					<br />
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Health/MedicalHistory.jsx